module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "CL-May-Week2.c9fa966e.png";